import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LayoutContainer from "../../../components/LayoutsContainer";
import { AccordionActions, Button, Grid } from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import AccordionList from "../../../components/AccordionList";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
  },
  achievementContainer: {
    marginTop: theme.spacing(2),
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  heading: {
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));

const GramSchemesLayout = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleNavigate = (link, extenral) => {
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };
  return (
    <div className={classes.root}>
      <LayoutContainer>
        <div>
          <Grid container direction="column" alignItems="flex-start">
            <Grid item className={classes.TitleContainer}>
              <TitleContainer title={data.title} />
            </Grid>
          </Grid>
        </div>
        <div className={classes.achievementContainer}>
          <AccordionList data={data?.data} type="scheme" />
        </div>
      </LayoutContainer>
    </div>
  );
};
export default GramSchemesLayout;
